import { FieldDropdown } from 'shared/ui'
import { useScheduleContext } from 'shared/ui/Schedule/context/ScheduleContext'
import { ScheduleTrigger } from './ui/ScheduleTrigger/ScheduleTrigger'
import { ScheduleDropdownContent } from './ui/ScheduleDropdownContent/ScheduleDropdownContent'

export const ScheduleDropdown = () => {
  const { placement } = useScheduleContext()

  return (
    <FieldDropdown
      offset={{ x: -4, y: -24 }}
      labelText={'Schedule'}
      placement={placement}
      customTriggerComponent={() => <ScheduleTrigger />}
      customComponent={(onCloseMenu, dropdownId) => (
        <ScheduleDropdownContent onCloseMenu={onCloseMenu} dropdownId={dropdownId} />
      )}
    />
  )
}
